import $ from 'jquery';

class Form {
    constructor(form) {
        this.$body = $('body');
        this.$window = $(window);
        this.$form = $(form);
        this.$errors = this.$form.find('.global-errors');

        this.errors = {
            generic: {
                pl: 'Błąd',
                en: 'Error'
            },
            alreadySubscribed: {
                pl: 'Podany e-mail jest już zapisany na newsletter.',
                en: 'The e-mail address has already been subscribed to the newsletter.'
            },
            errorOccured: {
                pl: 'Wystąpił błąd',
                en: 'An error occured'
            },
            requiredFields: {
                pl: 'Wypełnij wymagane pola',
                en: 'Complete the required fields'
            }
        };

        if (this.isSubmitted()) {
            this.hideForm();
        } else {
            this.events();
        }
    }

    track() {
        let data = {};
        let source = this.$form.attr('data-track-source'),
            name = this.$form.attr('data-track-name');

        if (source && source.length > 0) {
            data = {
                event: 'GAevent',
                eventCategory: 'newsletter',
                eventAction: 'wyslany email',
                eventLabel: source
            };
        }

        if (name && name.length > 0) {
            let $newsletter = this.$form.find('[name="newsletter"]:checked');

            data = {
                event: 'GAevent',
                eventCategory: name,
                eventAction: 'wyslany formularz',
                eventLabel: $newsletter.length ? $newsletter.val() : 0
            };
        }

        window.dataLayer.push(data);
        this.$form.attr('data-track-source', '');
    }

    checkRequired() {
        let filled = true;

        this.$form.find('[required]').each((id, el) => {
            let $el = $(el),
                isFilled;

            if ($el.is('[type="checkbox"]')) {
                isFilled = $el.is(':checked');
                $el.closest('.field').toggleClass('error', !isFilled);
            } else if ($el.is('[type="email"], [type="text"]')) {
                isFilled = $el.val();
                $el.closest('.field').toggleClass('error', !isFilled);
            }

            filled = filled && isFilled;
        });

        this.$errors.find('.error-message-required').toggle(!filled);

        return filled;
    }

    isSubmitted() {
        try {
            let submitted = JSON.parse(localStorage.getItem('submitted-ids'));

            return submitted.indexOf(this.$form.data('form-id')) >= 0;
        } catch(e) {

        }
    }

    hideForm() {
        this.$form.addClass('thank-you');
    }

    setSubmitted(id) {
        if (id) {
            try {
                let storage = localStorage.getItem('submitted-ids'),
                    submitted = storage ? JSON.parse(storage) : [];

                submitted.push(id);

                localStorage.setItem('submitted-ids', JSON.stringify(submitted));
            } catch(e) {

            }
        }
    }

    events() {
        this.$form
            .on('change', 'input, select, textarea', this.checkRequired.bind(this))
            .on('submit', e => {
                e.preventDefault();

                let lang = $('html').attr('lang');

                // if (this.checkRequired()) {
                this.$form.addClass('form-loading');

                $.post(this.$form.attr('action'), this.$form.serialize())
                    .done(data => {
                        this.$errors.html('');
                        this.$form.find('.error').removeClass('error');

                        if (data.errors) {
                            for (let name in data.errors) {
                                if (data.errors.hasOwnProperty(name)) {
                                    let $input = this.$form.find(`[name^="${name}"]`),
                                        $field = $input.closest('.field'),
                                        $msg = $field.find('.error-message');

                                    $field.addClass('error');
                                    $msg.html(data.errors[name]);
                                }
                            }
                        } else {
                            this.$form.addClass('thank-you');
                            this.hideForm();
                            this.setSubmitted(this.$form.data('form-id'));

                            // wysrodkuj thank-you na stronie
                            $('html, body').animate({scrollTop: this.$form.offset().top - $(window).outerHeight() / 2 + this.$form.find('.thank-you-content').outerHeight() / 2}, 200);

                            this.track();
                        }

                        this.$form.removeClass('form-loading');
                    })
                    .fail(() => {
                        this.$errors.html(`<div class="error-message">${this.errors.errorOccured[lang]}</div>`);

                        this.$form.removeClass('form-loading');
                    });
                // } else {
                //     this.$errors.html(`<div class="error-message error-message-required">${this.errors.requiredFields[lang]}</div>`);
                // }
            });

        this.$body.on('layer-closed', (e, layer) => {
            let $layer = $(layer);

            if ($layer.find(this.$form).length) {
                this.$form.find('input[type="text"], input[type="email"], textarea').val('');
                this.$form.find('input[type="checkbox"]:checked').prop('checked', false);
                this.$form.find('.field').removeClass('error');
                this.$form.find('.error-message').text('');
                this.$form.attr('data-track-source', '');

                this.$form.removeClass('thank-you');
            }
        });
    }
}

export default Form;



// WEBPACK FOOTER //
// ./sources/js/components/form.js